import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Image, Platform } from 'react-native';
import { Colors, Button, Icon, Line, Text } from '../components';
import { StringUtils } from '../utils';

class SignUpPriceSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      monthly_price: props.monthly_price,
      yearly_price: props.yearly_price,
      yearly_monthly_preview: props.year_mo_preview,
      six_month_price: props.six_month_price,
      six_months_monthly_preview: props.six_month_mo_preview,
      six_month_price_id: props.six_month_price_id,
      monthly_price_id: props.monthly_price_id
    }
  }

  componentDidMount() {
    console.log('price selection mounting')
    this.setState({
      monthly_price: this.props.monthly_price,
      yearly_price: this.props.yearly_price,
      yearly_monthly_preview: this.props.year_mo_preview,
      six_month_price: this.props.six_month_price,
      six_months_monthly_preview: this.props.six_month_mo_preview
    })
  }

  componentDidUpdate() {
    if(this.state.monthly_price !== this.props.monthly_price || this.state.yearly_price !== this.props.yearly_price || this.state.six_month_price !== this.props.six_month_price || this.state.yearly_monthly_preview !== this.props.year_mo_preview || this.state.six_months_monthly_preview !== this.props.six_month_mo_preview) {
      this.setState({
        monthly_price: this.props.monthly_price,
        yearly_price: this.props.yearly_price,
        yearly_monthly_preview: this.props.year_mo_preview,
        six_month_price: this.props.six_month_price,
        six_months_monthly_preview: this.props.six_month_mo_preview
      })
    }
  }

  render_selection_options = () => {
    let is_month_selected  = this.props.selected_duration === 'month';
    let is_year_selected   = this.props.selected_duration === 'year';
    let is_six_months_selected = this.props.selected_duration === 'six_months';

    let month_style_object = is_month_selected ? styles.option_selected : styles.option_unselected;
    let year_style_object  = is_year_selected  ? styles.option_selected : styles.option_unselected;
    let six_months_style_object = is_six_months_selected ? styles.option_selected : styles.option_unselected;

    let monthly_price    = this.state.monthly_price;
    let yearly_price     = this.state.yearly_price;
    let six_month_price  = this.state.six_month_price;

    let display_monthly  = monthly_price   !== '0.00';
    let display_yearly   = yearly_price    !== '0.00';
    let display_6_month  = six_month_price !== '0.00';

    let six_months_monthly_preview = this.state.six_months_monthly_preview;
    let yearly_monthly_preview     = this.state.yearly_monthly_preview;

    return <View style={{ marginBottom: 15 }}>
      <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 12, alignSelf: 'center' }}>Your Virtual Care Membership</Text>

      { display_monthly ? <TouchableOpacity style={month_style_object}
                                            onPress={ () => {
                                              if (this.props.on_change_duration) {
                                                this.props.on_change_duration('month');
                                              }
                                            }}>
                            <Icon style={{ marginRight: 10, marginLeft: 5 }} solid={ is_month_selected ? true : false } name={ is_month_selected ? 'check-circle' : 'circle' } color={ is_month_selected ? Colors.GREEN : Colors.BORDER_GREY } />
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', flex: 1, alignItems: 'center' }}>
                              <Text style={styles.price_amount_text}>{ '$' +  monthly_price + ' ' + 'Monthly' }</Text>
                              <View style={{ backgroundColor: '#C5AAF0', paddingRight: 12, paddingLeft: 12, paddingTop: 5, paddingBottom: 5, borderRadius: 15 }}>
                                <Text style={{ color: '#333333', fontWeight: '500', fontSize: 11 }}>AFTER FREE TRIAL</Text>
                              </View>
                            </View>
                          </TouchableOpacity> : null }

      { display_yearly ?  <TouchableOpacity style={year_style_object}
                                            onPress={ () => {
                                              if (this.props.on_change_duration) {
                                                this.props.on_change_duration('year');
                                              }
                                            }}>
                            <Icon style={{ marginRight: 10, marginLeft: 5 }} solid={ is_year_selected ? true : false } name={ is_year_selected ? 'check-circle' : 'circle' } color={ is_year_selected ? Colors.GREEN : Colors.BORDER_GREY } />
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', flex: 1 }}>
                              <Text style={styles.price_amount_text}>{ '$' + yearly_price + ' ' + 'Annual' }</Text>
                              <Text style={styles.price_amount_text}>{ '( $' + yearly_monthly_preview + ' / Month ' + ')' }</Text>
                            </View>
                          </TouchableOpacity> : null }

      { display_6_month ? <TouchableOpacity style={six_months_style_object}
                                            onPress={ () => {
                                              if (this.props.on_change_duration) {
                                                this.props.on_change_duration('six_months');
                                              }
                                            }}>
                            <Icon style={{ marginRight: 10, marginLeft: 5 }} solid={ is_six_months_selected ? true : false } name={ is_six_months_selected ? 'check-circle' : 'circle' } color={ is_six_months_selected ? Colors.GREEN : Colors.BORDER_GREY } />
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', flex: 1 }}>
                              <Text style={styles.price_amount_text}>{ '$' +  six_month_price + ' ' + ' / 6 Months' }</Text>
                              <Text style={{ color: Colors.PRIMARY, fontWeight: '500' }}>{ '( $' + six_months_monthly_preview + ' / Month ' + ')' }</Text>
                            </View>
                          </TouchableOpacity> : null }

    </View>
  }

  render_product_features_list = () => {
    let is_month_selected  = this.props.selected_duration === 'month';
    return <View style={{ alignItems: 'center' }}>

      { is_month_selected ? <View>
        <Text style={{ fontSize: 17, marginBottom: 12, alignSelf: 'center', fontWeight: '500' }}>START YOUR 7-DAY FREE TRIAL</Text>
        <View style={{ height: 10 }}></View>
      </View> : null }

      <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 12, alignSelf: 'center' }}>What's Included?</Text>
      <View style={styles.feature_list_item}>
        <View style={styles.feature_check_container}><Icon name='check-circle' solid={true} /></View>
        <View style={styles.feature_text_container}><Text style={styles.product_feature}>Unlimited chats and video sessions with licensed veterinary professionals</Text></View>
      </View>
      <View style={styles.feature_list_item}>
        <View style={styles.feature_check_container}><Icon name='check-circle' solid={true} /></View>
        <View style={styles.feature_text_container}><Text style={styles.product_feature}>Connect with the same pro who knows you and your pet best</Text></View>
      </View>
      <View style={styles.feature_list_item}>
        <View style={styles.feature_check_container}><Icon name='check-circle' solid={true} /></View>
        <View style={styles.feature_text_container}><Text style={styles.product_feature}>Stage-specific and seasonal coaching for every step of pet parenting</Text></View>
      </View>
      <View style={styles.feature_list_item}>
        <View style={styles.feature_check_container}><Icon name='check-circle' solid={true} /></View>
        <View style={styles.feature_text_container}><Text style={styles.product_feature}>Cancel your subscription anytime</Text></View>
      </View>
    </View>
  }

  render_continue_button = () => {
    return <View style={{ paddingTop: 15 }}>
      <Button title='Continue'
              style={{  }}
              loading={this.props.continue_btn_loading}
              onPress={ () => {
                if (this.props.continue_btn_action) {
                  this.props.continue_btn_action();
                }
              }}/>
    </View>
  }

  render() {

    if (!this.props.display) {
      return null;
    }

    let image_bottom_padding = Platform.OS === 'web' ? 30 : 0;

    return (

      <View style={styles.main_container}>
        <View style={{ paddingTop: 30 }}>
          <View style={styles.couch_image_container}>
            <Image style={styles.couch_image} source={ require('../assets/images/sign-up-couch.png') } />
          </View>
          <View style={{ height: image_bottom_padding }}></View>
          <View style={styles.content_container}>
            <View>
              { this.render_selection_options()     }
              <Line style={{ marginBottom: 20 }}/>
              { this.render_product_features_list() }
            </View>
          </View>
        </View>
        { this.render_continue_button() }
      </View>

    );
  }

}

const styles = StyleSheet.create({
  content_container: {
    backgroundColor: 'white',
    paddingTop: 100
  },
  couch_image: {
    height: 120,
    width: 120
  },
  couch_image_container: {
    width: '100%',
    position: 'absolute',
    zIndex: 3,
    elevation: 3,
    alignItems: 'center'
  },
  feature_check_container: {
    width: 40
  },
  feature_text_container: {
    width: 250
  },
  feature_list_item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15
  },
  main_container: {
    flex: 1,
    padding: 20,
    paddingTop: 0,
  },
  option_unselected: {
    borderWidth: 2,
    borderColor: '#e7e7e7',
    padding: 10,
    borderRadius: 10,
    marginBottom: 5,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 16
  },
  option_selected: {
    borderWidth: 2,
    borderColor: Colors.PRIMARY,
    padding: 10,
    borderRadius: 10,
    marginBottom: 5,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 16
  },
  price_amount_text: {
    color: '#575762',
    fontSize: 15
  },
  product_feature: {
    color: '#575762',
    fontSize: 15
  }
});

export default SignUpPriceSelection
